import React from 'react';
import banerscreen from '../../../assets/images/home/baner-screen.png';
import { useNavigate } from 'react-router-dom';
import LogoCom from './LogoCom';
import Header from './header';

const Welcomes = () => {

    const navigate = useNavigate();


    return (
        <>
            <Header />
            <div className='wellcome-box'>
                <div className='container '>
                    <div className='row mt-3'>
                        <div className='col-xl-6 col-lg-12 col-md-12 pr-10 text-xl-start text-lg-center  text-md-center text-sm-center'>
                            <div data-aos="fade-down" >
                                <h1 className='text-white mb-2 h1-large'>Learn the Skillz that Matter</h1>
                                <p className='text-white text-wrap'>Z and his family will walk you through short lessons with follow up questions, watch you unlock quests and encourage you to compete against other users. Gain the SharkSkillz you need.</p>
                                <div className='app-button mt-5 text-xl-start text-lg-center  text-md-center text-sm-center'>
                                    <a target='_blank' href="https://play.google.com/store/apps/details?id=com.gologonow.sharkSkills&pcampaignid=web_share" className='play-store'></a>
                                    <a target='_blank' href="https://apps.apple.com/us/app/sharkskillz/id6714483981" className='app-store'></a>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-12 col-md-12  text-center'>
                            <div data-aos="fade-up" >
                                <img className='screenMaxWidth' src={banerscreen} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>


    )
}

export default Welcomes
